module.exports = __webpack_public_path__ + "static/media/Region_20_Executive_Committee_Minutes_Website_06_05_2025.7bcea5e7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/25-26/Region_20_Executive_Committee_Minutes_Website_06_05_2025.pdf
// module id = 248
// module chunks = 0